import { emptyMarket } from "../../constants";
import { CardType, ComponentType } from "../../data";
export const getCardPropsEventWithMbn = (event, markets) => {
    const shouldShowMbn = (event.cardType === CardType.Regular
        || event.componentType === ComponentType.LiveOutright
        || event.componentType === ComponentType.PreLiveOutright);
    const market = shouldShowMbn && markets.length ? markets[0] : emptyMarket;
    return Object.assign(Object.assign({}, event), { mbnIcon: market.mbnIcon });
};
//# sourceMappingURL=getCardPropsEventWithMbn.js.map